// extracted by mini-css-extract-plugin
export default {"summary":"summary__TcuqySrs","summaryCards":"summary-cards__slYSx2xK","summaryCard":"summary-card__lekKgBUn","subheader":"subheader__rUfHAFr1","noGap":"no-gap__Ofo5J7RT"};